import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"eroom",
    list_id:"eroom_list",
    x_column_list_arr:[
      {"key":"a_name","name":"이름","width":"150","is_show":"1"},
      // {"key":"a_location","name":"위치","width":"120","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"90","is_show":"1"},
      {"key":"row_view_xy","name":"크기","width":"70","is_show":"1"},
      {"key":"row_view_order","name":"순서","width":"70","is_show":"1"},
      // {"key":"a_create_date","name":"작성일","width":"180","is_show":"1"},
      // {"key":"a_update_date","name":"수정일","width":"180","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':10,
      'order_id':'a_order_num, a_name',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;